export default "__VITE_ASSET__DIlCZTCJ__"